// ChatbotWidget.jsx
import { useState } from 'react';

import { MessageCircle } from 'lucide-react';

import Chatbot from './chatboot';
import styles from './ChatbotWidget.module.css';

function ChatbotWidget() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleChatbot = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={styles.chatbotWidget}>
      {isOpen && (
        <div className={styles.chatbotWindow}>
          <div className={styles.chatbotHeader}>
            <span className={styles.chatbotHeaderTitle}>
              BKBO EXPAT Assistant
            </span>
            <button className={styles.chatbotCloseButton} onClick={toggleChatbot}>
              ✕
            </button>
          </div>
          <Chatbot />
        </div>
      )}
      <button className={styles.chatbotToggle} onClick={toggleChatbot}>
        <MessageCircle size={24} />
      </button>
    </div>
  );
}

export default ChatbotWidget;
